angular.module('scroller')
    .directive('scroller', scrollerDirective);

scrollerDirective.$inject = ['$window'];
function scrollerDirective($window){
    var directive = {
        restrict: 'EA',
        scope: {
            count: '='
        },
        link: linkFunc,
        controller: scrollerController,
        controllerAs: 'vm',
        bindToController: true
    };
    return directive;

    function linkFunc(scope, element, attrs){
        angular.element($window).bind("scroll", function(){
            scope.vm.increaseTimerCount();
        });
    }
}

scrollerController.$inject = ['$scope'];
function scrollerController($scope){
    var vm = this;
    vm.increaseTimerCount = increaseTimerCount;

    function increaseTimerCount(){
        $scope.vm.count++;
        $scope.$apply();
    }
}
